// walletBus.js

import { ref } from 'vue'
export const bus = ref(new Map())
